<template>
  <div>
    <p class='mb-5'>{{ formHeaderText | translate }}</p>

    <info-container v-if="isLastClosedReportOfSicknessSmallerThanMonthAgo"
      :text="$t('report-of-sickness.warnings.one-month-since-last-closed')"
      title='Let op: Laatste herstel is minder dan 28 dagen geleden.' class="mb-5"/>

    <form-input-container
      title='Geselecteerde Werknemer'
      text='De werknemer die u in de vorige stap heeft geselecteerd.'>
      <employee-card :employee="this.employee" showPolicies :policyCoverageDate="reportOfSickness.firstOfAbsence"/>
    </form-input-container>

    <report-of-sickness-form :isEditing="false" :employee="this.employee" />

    <div style='float: right' class='mt-4'>
      <Button primary class="mr-3" @click="this.handlePreviousClick">
        {{ 'buttons.previous-step' | translate }}
      </Button>
      <Button secondary
        @click="this.handleContinueClick"
        :disabled="!(requiredFields.isValid() && validations.isValid())"
        :hoverErrors="hoverErrors">
        {{ 'buttons.next-step' | translate }}
      </Button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import Compositions from '@/views/helpers/compositions';

import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';
import FormInputContainer from '@aevitae/aevitaeui/0_atoms/containers/FormInputContainer.vue';
import InfoContainer from '@aevitae/aevitaeui/1_molecules/containers/InfoContainer.vue';

import ReportOfSicknessForm from '@/views/components/reports-of-sickness/ReportOfSicknessForm.vue';
import EmployeeCard from '@/views/components/employees/EmployeeCard.vue';

import NRS from '@/views/constants/report-of-sickness-new';

export default {
  name: 'NewReportOfSicknessForm',
  components: {
    Button,
    ReportOfSicknessForm,
    EmployeeCard,
    InfoContainer,
    FormInputContainer
  },
  computed: {
    ...mapGetters({
      reportsOfSickness: 'reportsOfSickness',
      validations: 'newReportOfSicknessValidations',
      requiredFields: 'newReportOfSicknessRequiredFields',
      reportOfSickness: 'newReportOfSickness'
    }),

    selectedEmployeeId: {
      set (value) {
        this.$store.dispatch(NRS.Actions.SelectedEmployee.CHANGE, value).then(
          this.$store.dispatch(NRS.Actions.Steps.Completed.UPDATE));
      },
      get () { return this.$store.getters.newReportOfSickness.employeeId; }
    },

    employee () {
      const selectedEmployeeId = this.$store.getters.newReportOfSickness.employeeId;
      const employees = this.$store.getters.employees;

      if (!_.isEmpty(employees) && !_.isNil(selectedEmployeeId)) {
        return _.find(employees, employee => employee.id === selectedEmployeeId);
      } else {
        return null;
      }
    },

    employeePolicyTypes () {
      return _.uniq(Compositions.getEmployeePolicies(
        this.employee, this.$store.getters.activePolicies).map(p => p.productType));
    },

    isLastClosedReportOfSicknessSmallerThanMonthAgo () {
      if (this.reportsOfSickness.hasOwnProperty(this.employee.id)) {
        return Compositions.isFirstOfAbsenceWithinBufferLastReport(this.reportsOfSickness[this.employee.id]);
      }
      return false;
    },

    formHeaderText () {
      if (this.employeePolicyTypes.length === 1) {
        if (this.employeePolicyTypes[0] === 'WIA') return 'report-of-sickness.form.new-description-wia-only';
        else if (this.employeePolicyTypes[0] === 'VZM') return 'report-of-sickness.form.new-description-vzm-only';
      }
      return 'report-of-sickness.form.new-description-multi';
    },

    hoverErrors () {
      if (!this.requiredFields.isValid()) {
        return [this.$t('errors.provide-all-required-fields')];
      } else return [];
    }
  },
  methods: {
    handleContinueClick () {
      this.$store.dispatch(
        NRS.Actions.Navigate.DO,
        NRS.Views.NewReportOfSicknessConfirmation);
    },
    handlePreviousClick () {
      this.$store.dispatch(
        NRS.Actions.Navigate.DO,
        NRS.Views.SelectEmployeeForm);
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/variables.scss';

  .input-container {
    padding: 20px 0px;

    p {
      margin-bottom: 30px;
    }
  }
</style>
